import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {GLOBAL} from "./GLOBAL";
import {Observable} from "rxjs";
import {MsalService} from "@azure/msal-angular";

@Injectable({
  providedIn: 'root'
})
export class CitaService {

  public url;

  constructor( private _http : HttpClient, private msalService: MsalService) {
    this.url = GLOBAL.url;
  }

  async listarServicios(data: { recaptchaToken: string; recaptchaAction: string }): Promise<Observable<any>> {
    const fd = new FormData();
    fd.append('recaptchaToken', data.recaptchaToken);
    fd.append('recaptchaAction', data.recaptchaAction);

    return this._http.post(this.url + 'cita/listarServicios', fd);
  }

  listarAgendas(data: {
    recaptchaToken: string;
    recaptchaAction: string;
    servicio: string;
    fecha_inicio?: string;
    fecha_fin?: string;
  }): Observable<any>{
    const fd = new FormData();
    if (data.fecha_inicio) {
      fd.append('fecha_inicio', data.fecha_inicio);
    }
    if (data.fecha_fin) {
      fd.append('fecha_fin', data.fecha_fin);
    }
    fd.append('servicio', data.servicio);
    fd.append('recaptchaToken', data.recaptchaToken);
    fd.append('recaptchaAction', data.recaptchaAction);
    return this._http.post(this.url + 'cita/listarAgenda',fd);
  }

  async registro(data: {
    recaptchaToken: string;
    recaptchaAction: string;
    servicio: string;
    fecha: string;
    agendas: string[];
    nombre: string;
    cedula: string;
    correo: string;
    sexo?: number | string;
    telefono?: string;
    expediente?: string;
    fechaNacimiento?: string;
    primerApellido: string;
    segundoApellido?: string;
    tipoIdentificacion?: string;
  }): Promise<Observable<any>> {
    const fd = new FormData();
    fd.append('fecha', data.fecha);
    fd.append('servicio', data.servicio);
    data.agendas.forEach(agendaId => fd.append('agenda[]', agendaId));
    fd.append('nombre', data.nombre);
    fd.append('cedula', data.cedula);
    fd.append('correo', data.correo);
    if (data.sexo !== undefined && data.sexo !== null) {
      fd.append('sexo', String(data.sexo));
    }
    if (data.telefono) {
      fd.append('telefono', data.telefono);
    }
    if (data.expediente) {
      fd.append('expediente', data.expediente);
    }
    if (data.fechaNacimiento) {
      fd.append('fechaNacimiento', data.fechaNacimiento);
    }
    fd.append('primerApellido', data.primerApellido);
    if (data.segundoApellido) {
      fd.append('segundoApellido', data.segundoApellido);
    }
    if (data.tipoIdentificacion) {
      fd.append('tipoIdentificacion', data.tipoIdentificacion);
    }
    fd.append('recaptchaToken', data.recaptchaToken);
    fd.append('recaptchaAction', data.recaptchaAction);

    return this._http.post(this.url + 'cita/registrarCita', fd);

  }

  async registrov2(data): Promise<Observable<any>> {
    return this._http.post(this.url + 'cita/registrarCita', {});
  }

  listarCitas(data: {
    recaptchaToken: string;
    recaptchaAction: string;
    servicio: string;
    agendas: string[];
    fecha_inicio?: string;
    fecha_fin?: string;
  }): Observable<any> {
    const fd = new FormData();
    if (data.fecha_inicio) {
      fd.append('fecha_inicio', data.fecha_inicio);
    }
    if (data.fecha_fin) {
      fd.append('fecha_fin', data.fecha_fin);
    }
    fd.append('servicio', data.servicio);
    data.agendas.forEach(agendaId => fd.append('agenda[]', agendaId));
    fd.append('recaptchaToken', data.recaptchaToken);
    fd.append('recaptchaAction', data.recaptchaAction);
    return this._http.post(this.url + 'cita/listarCitas',fd);
  }

  getDatosPacientes(data: { recaptchaToken: string; recaptchaAction: string; cedula: string }):Observable<any>{
    const fd = new FormData();
    fd.append('cedula',data.cedula);
    fd.append('recaptchaToken',data.recaptchaToken);
    fd.append('recaptchaAction',data.recaptchaAction);
    return this._http.post(this.url + 'cita/getDatosPaciente',fd);
  }
}
